import { ComprobanteGalleryItem } from '../types/Reintegro/types';

const isPdfFile = (url: string, mimeType?: string | null): boolean => {
  if (mimeType === 'application/pdf') return true;
  return url.toLowerCase().includes('.pdf') || url.startsWith('data:application/pdf');
};

const isVideoFile = (url: string, mimeType?: string | null): boolean => {
  if (mimeType?.startsWith('video/')) return true;

  return (
    url.startsWith('data:video/') ||
    /\.(mp4|mov|m4v|webm|ogg)(?:[?#].*)?$/i.test(url)
  );
};

const isComprobanteItem = (
  file: string | ComprobanteGalleryItem,
): file is ComprobanteGalleryItem => typeof file === 'object' && 'file' in file;

export { isPdfFile, isVideoFile, isComprobanteItem };
